import { useState } from "react";
import { Reveal, SectionEyebrow } from "./Reveal";
import { INDUSTRIES } from "../../data";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { openInquiry } from "../../lib/inquiry";

export const Industries = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="industries" className="bg-white py-20 md:py-28" data-testid="industries">
      <div className="container-oyf">
        <div className="max-w-3xl">
          <SectionEyebrow>Industries Served</SectionEyebrow>
          <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
            Freight Support for Businesses That Cannot Afford Unnecessary Delays
          </h2>
          <p className="mt-4 text-oyf-medgrey">Select an industry to learn how we support it.</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-px bg-oyf-grey border border-oyf-grey rounded-lg overflow-hidden">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.t} delay={(i % 2) * 0.06}>
              <button
                onClick={() => setActive(ind)}
                className="group w-full text-left flex items-center justify-between gap-4 bg-white p-6 hover:bg-oyf-charcoal transition-colors duration-300 cursor-pointer"
                data-testid={`industry-${i}`}
              >
                <div className="flex items-center gap-4">
                  <span className="font-display font-extrabold text-oyf-yellow text-xl w-8">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display font-bold text-oyf-black group-hover:text-white text-lg transition-colors">{ind.t}</span>
                </div>
                <Plus size={18} className="text-oyf-grey group-hover:text-oyf-yellow group-hover:rotate-90 transition-all duration-300 shrink-0" />
              </button>
            </Reveal>
          ))}
        </div>

        <p className="mt-6 text-sm text-oyf-medgrey max-w-3xl leading-relaxed">
          Shipment acceptance is subject to cargo type, dimensions, weight, packaging, route, insurance conditions, vehicle availability and applicable regulations.
        </p>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-lg w-[95vw] bg-white" data-testid="industry-modal">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-oyf-black">{active?.t}</DialogTitle>
          </DialogHeader>
          <p className="text-oyf-medgrey leading-relaxed">{active?.d}</p>
          <button
            onClick={() => { setActive(null); openInquiry(`Industry: ${active?.t}`); }}
            className="mt-2 w-full bg-oyf-yellow text-oyf-black font-bold py-3.5 rounded-md hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_#202124] transition-transform duration-200"
            data-testid="industry-modal-inquiry"
          >
            Send an Inquiry
          </button>
        </DialogContent>
      </Dialog>
    </section>
  );
};
